import cx from 'classnames';

import { loc } from '@/localization';

import { b } from './style.css';

export function Separator({ className }: { className?: string }) {
    return <div className={cx(b.name, className)}>{loc.Main.Or}</div>;
}
